module.exports = __webpack_public_path__ + "static/media/s_t.4be77fae.png";